import { Component, OnInit, Inject, Output, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';


import { CommonService, AlertService, AdminService } from '../../../_services/';
import { AngularFireStorage } from '@angular/fire/storage';
import { map, finalize } from "rxjs/operators";
import { Observable, Subscription } from "rxjs";

@Component({
  selector: 'app-project-map-step-needed-docs',
  templateUrl: './project-map-step-needed-docs.component.html',
  styleUrls: ['./project-map-step-needed-docs.component.scss']
})
export class ProjectMapStepNeededDocsComponent implements OnInit {
  addNewProjectMapCategoryFileForm:FormGroup;
  submitted:Boolean=false;
  successMsg:String;
  errMsg:String;
  selectedFile: File;
  projectMapStepCategory:any[] = [];
  projectMapStepCategoryId:String;
  categoryName : String;
  editMode:Boolean= false;
  fileSelected :Boolean = false;
  downloadURL: Observable<string>;
  ref:any;
  editFileId:String;
  projectMapStepId:String;
  projectMapStepCatFile:any[] =[];
  private subscription : Subscription;
  constructor(
    public dialogRef: MatDialogRef<ProjectMapStepNeededDocsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private _common : CommonService,
    private _alert : AlertService,
    private _admin : AdminService,
    private afStorage: AngularFireStorage
  ) { }

  ngOnInit() {
    
    this.categoryName = this.data.name? this.data.name:'';
    this.projectMapStepCategoryId = this.data.id;
    this.projectMapStepId = this.data.project_map_step_id;
    this.getProjectMapCategoryFileList();
    this.addNewProjectMapCategoryFileForm = this.fb.group({
      name : [null, [Validators.required, Validators.maxLength(50)]],
      doc : [null, []]
    }) 
  }

  getProjectMapCategoryFileList(){
    this._common.showLoader(true);
    this.subscription = this._admin.getProjectMapCatetoryFileList(this.projectMapStepCategoryId).subscribe(result=>{
      this._common.showLoader(false);
      this.projectMapStepCatFile = result;
      
    },err=>{
      this._common.showLoader(false);
      this._alert.error(err.error.message?err.error.message:'Something went wrong!');
    })
  }

  hideProjectMapCategoryFileDialog(){
    this.dialogRef.close();
  }

  get fval() {
    return this.addNewProjectMapCategoryFileForm.controls;
  }

  onFileChanged(event) {
    this.selectedFile = event.target.files[0];
    this.fileSelected = true;
  }


  onFormSubmit():void {
    this.errMsg ="";
    this.successMsg = "";
    this.submitted = true;
    if (this.addNewProjectMapCategoryFileForm.invalid) {
      return;
    }
    let form = this.addNewProjectMapCategoryFileForm.value;
    form.uid = localStorage.getItem('uid');
    form.project_map_step_id = this.projectMapStepCategoryId;
    
    if(this.editMode==true){

      this._common.showLoader(true);
      if(this.fileSelected===true){
         // upload file to storage
      const randomId = Math.random().toString(36).substring(2);
      const fileName = `${randomId}-${this.selectedFile.name}`
      this.ref = this.afStorage.ref(`docs/${randomId}-${this.selectedFile.name}`);
      const task = this.afStorage.upload(`docs/${randomId}-${this.selectedFile.name}`,this.selectedFile);

      task.snapshotChanges().pipe(
        finalize(() => {
          this.downloadURL = this.ref.getDownloadURL();
          this.downloadURL.subscribe(url => {
            if (url) {
              let data ={
                name : this.addNewProjectMapCategoryFileForm.value.name,
                file_download_url : url
              }
              this._admin.editProjectMapStepCategoryFile(data,this.editFileId).then(res => {
                this._common.showLoader(false);
                // this.dialogRef.close();
                // this._alert.success();
                this.editMode = false;
                this.editFileId = ''; 
                this.submitted = false;
                this.addNewProjectMapCategoryFileForm.reset();
                this.successMsg = "Project map step category file edited successfully!";
                
              },err=>{
                this._common.showLoader(false);
                this.errMsg = err.message ? err.message: "Something went wrong";
              }) 

            }
          });
        })
      ).subscribe(url => {})

      }
      else{
        let data ={
          name : this.addNewProjectMapCategoryFileForm.value.name
        }
        this._admin.editProjectMapStepCategoryFile(data,this.editFileId).then(res => {
          this._common.showLoader(false);
          // this.dialogRef.close();
          // this._alert.success();
          this.editMode = false;
          this.editFileId = ''; 
          this.submitted = false;
          this.addNewProjectMapCategoryFileForm.reset();
          this.successMsg = "Project map step category file edited successfully!";
          
        },err=>{
          this._common.showLoader(false);
          this.errMsg = err.message ? err.message: "Something went wrong";
        }) 
      }
     
    }
    else {
      if(!this.fileSelected){
        this.errMsg = 'File not selected!';
        return;
      } 
      this._common.showLoader(true);
      // upload file to storage
      const randomId = Math.random().toString(36).substring(2);
      const fileName = `${randomId}-${this.selectedFile.name}`
      this.ref = this.afStorage.ref(`docs/${randomId}-${this.selectedFile.name}`);
      const task = this.afStorage.upload(`docs/${randomId}-${this.selectedFile.name}`,this.selectedFile);

      task.snapshotChanges().pipe(
        finalize(() => {
          this.downloadURL = this.ref.getDownloadURL();
          this.downloadURL.subscribe(url => {
            if (url) {
              form.file_download_url = url;
              form.project_map_step_id = this.projectMapStepId;
              form.project_map_step_category_id = this.projectMapStepCategoryId;
              this._admin.createProjectMapCategoryFile(form).subscribe(res => {
                this._common.showLoader(false);
                this.submitted = false;
                this.addNewProjectMapCategoryFileForm.reset();
                this.successMsg = res.message;
              },err=>{
                this.dialogRef.close();
                this._common.showLoader(false);
                this.errMsg = err.error.message?err.error.message:'Something went wrong!';
              }) 

            }
          });
        })
      ).subscribe(url => {})
      this.fileSelected = false; 
    }
  }

  deleteProjectMapCategoryFileById(file_id){
    this._common.showLoader(true);
    this._admin.deleteProjectMapCategoryFileById(file_id).then((res)=>{
      this.cancelEdit();
      this._common.showLoader(false);
      this.successMsg = 'Project map step category file deleted successfully!';
    }).catch(err=>{
      this._common.showLoader(false);
      this.errMsg = err.error.message?err.error.message:'Something went wrong!';
    })
  }

  cancelEdit(){
    this.editMode = false;
    this.editFileId = ''; 
    this.addNewProjectMapCategoryFileForm.reset();
  }

  openEditProjectMapFieldDialog(id,data){
    this.successMsg = "";
    this.errMsg = "";
    this.editMode = true;
    this.editFileId = id; 
    this.addNewProjectMapCategoryFileForm.patchValue({
      name : data.name
    })   
  }


  ngOnDestroy(){
    if(this.subscription) this.subscription.unsubscribe();
  }

}


